import React from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'

// Temporary react router 5 setup as we need to map *
// to protected route for federated module support.
// Should be removed when using react router 6
const nonProtectedRoutes = [
  '/confirm-email',
  '/password/activate',
  '/password/forgot',
  '/edit-profile',
  '/store/select',
]

const ProtectedRoute = ({
  loggedIn,
  authority,
  container,
  authorities,
  exact,
  path,
}) => {
  const location = useLocation()
  const hasAuthority = () => {
    if (authority === null) {
      return true
    }
    return authorities.indexOf(authority) >= 0
  }

  const getContainer = () => {
    if (loggedIn) {
      return hasAuthority() ? container : <Redirect to="/" />
    }
    if (nonProtectedRoutes.includes(location.pathname)) {
      return null
    }
    return <Redirect to="/login" />
  }

  return <Route exact={exact} path={path} render={() => getContainer()} />
}

ProtectedRoute.propTypes = {
  path: PropTypes.string.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  container: PropTypes.object,
  authorities: PropTypes.array.isRequired,
  authority: PropTypes.string,
  exact: PropTypes.bool,
}

ProtectedRoute.defaultProps = {
  authority: null,
  exact: false,
  container: null,
}

const mapStateToProps = state => ({
  loggedIn: state.auth.isLoggedIn,
  authorities: state.auth.authorities,
})

export default connect(mapStateToProps, null)(ProtectedRoute)
